module.exports = __webpack_public_path__ + "static/media/avatars_male_16.290c5532.png";